module.exports = __webpack_public_path__ + "img/product_list_icon.b552beb1.png";